"use strict";

exports.__esModule = true;
exports.default = unsetGrabCursor;

function unsetGrabCursor() {
  var swiper = this;

  if (swiper.support.touch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) {
    return;
  }

  swiper.el.style.cursor = '';
}


//////////////////
// WEBPACK FOOTER
// ./~/swiper/cjs/components/core/grab-cursor/unsetGrabCursor.js
// module id = 82
// module chunks = 0